import React, { forwardRef } from 'react';

import '../styles/Caption.css';

import { ReactComponent as AssetIconEdit } from '../resources/assets/iconEdit.svg'; 

const Caption = ({ text, edit }) => {

    const handleClick = () => {
        if(edit) {
            edit();
        }
    };
    return (
        <div className='caption-panel'>
            <div className='caption-text'>{text}</div>
            { edit ? <div className='caption-edit' onClick={handleClick}><AssetIconEdit /></div> : "" }
        </div>
    );
};

export default Caption;